// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"114":"693c8e38","322":"b8f8ea8d","361":"9f664829","415":"4ea1e4cd","891":"0e39f738"}[chunkId] + ".chunk.css";
};